import React, { useState, useEffect } from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

import { useApi } from "../../../api";
import useDevice from "../../../domain/device/useDevice";
import { REGEXP_ID } from "../../../utils/stringUtils";
import Maintenance from "./Maintenance";
import List from "./List";
import Filter from "./Filter";
import DeleteContainer from "./DeleteContainer";
import CreateMaintenance from "./Create";
import EditMaintenance from "./Edit";

export const ALL_VALUE = "_all_";
const DEFAULT_MAINTENANCE_LIMIT = 10;

const MaintenanceContainer = ({ device }) => {
  const api = useApi();
  const history = useHistory();
  const { url } = useRouteMatch();
  const { reload: reloadDevice } = useDevice();

  const [records, setRecords] = useState([]);
  const [maintenanceLimit, setMaintenanceLimit] = useState(
    DEFAULT_MAINTENANCE_LIMIT
  );
  const [isLoading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [filter, setFilter] = useState({ status: ALL_VALUE });
  const [confirmDelete, setConfirmDelete] = useState(null);

  useEffect(() => {
    if (!reload) {
      return;
    }

    setReload(false);
    setLoading(true);

    let query = `device_id=${device.id}`;
    if (filter.status !== ALL_VALUE) {
      query += `&status=${filter.status}`;
    }

    api
      .get(`/v2/maintenance?${query}`)
      .then(response => {
        setRecords(response.data);

        const limitHeader = response.headers["x-maintenance-limit"];
        setMaintenanceLimit(
          limitHeader !== undefined
            ? parseInt(limitHeader, 10)
            : DEFAULT_MAINTENANCE_LIMIT
        );
      })
      .catch(() => {})
      .then(() => setLoading(false));
  }, [api, device, filter, reload]);

  const handleFilterChange = values => {
    setFilter(values);
    setReload(true);
  };

  const handleCreate = () => history.push(`${url}/new`);
  const handleEdit = record => history.push(`${url}/${record.id}`);

  const handleClose = saved => {
    if (saved) {
      setReload(true);
      reloadDevice();
    }
    history.push(url);
  };

  return (
    <>
      <Switch>
        <Route path={`${url}/new`}>
          <CreateMaintenance device={device} onClose={handleClose} />
        </Route>
        <Route path={`${url}/:maintenanceId(${REGEXP_ID})`}>
          {({
            match: {
              params: { maintenanceId }
            }
          }) => (
            <EditMaintenance
              maintenanceId={maintenanceId}
              onClose={handleClose}
            />
          )}
        </Route>
      </Switch>

      {confirmDelete !== null && (
        <DeleteContainer
          maintenanceId={confirmDelete.id}
          onCancel={() => setConfirmDelete(null)}
          onDeleted={() => {
            setReload(true);
            reloadDevice();
            setConfirmDelete(null);
          }}
        />
      )}

      <Maintenance
        filterComponent={
          <Filter values={filter} onChange={handleFilterChange} />
        }
        tableComponent={
          <List
            device={device}
            records={records}
            maintenanceLimit={maintenanceLimit}
            isLoading={isLoading}
            onCreate={handleCreate}
            onEdit={handleEdit}
            onDelete={setConfirmDelete}
          />
        }
      />
    </>
  );
};

export default MaintenanceContainer;
